<template>
  <div></div>
</template>

<script>
import Point from "ol/geom/Point.js";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { Style, Circle, Fill } from "ol/style";
import Feature from "ol/Feature";
import Text from "ol/style/Text.js";
export default {
  name: "OlMarker",
  props: {
    position: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: "#409EFF",
    },
    label: {
      type: String,
      default: "",
    },
    fontSize: {
      type: Number,
      default: 10,
    },
    pointImageVisible: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let position = this.position;

      position = this.$parent.worldToRosMap(position[0], position[1]);

      // 初始化矢量源（存储点要素）
      this.vectorSource = new VectorSource();

      // 矢量图层配置
      const vectorLayer = new VectorLayer({
        source: this.vectorSource,
        style: this.getPointStyle(),
      });
      this.$vectorLayer = vectorLayer;
      const point = new Point(position);
      this.$point = point;
      const pointFeature = new Feature({
        geometry: point,
      });
      this.vectorSource.addFeature(pointFeature);
      this.$parent.$map.addLayer(vectorLayer);
    },
    getPointStyle() {
      let config = {};
      let offsetY = 10;
      if (this.pointImageVisible) {
        config.image = new Circle({
          radius: 4,
          fill: new Fill({ color: this.color }),
        });
      } else {
        offsetY = 0;
      }
      if (this.label) {
        config.text = new Text({
          text: this.label,
          fill: new Fill({ color: "#000" }),
          font: `${this.fontSize}px`,
          offsetX: 0,
          offsetY: offsetY,
          textAlign: "center",
          textBaseline: "middle",
        });
      }
      return new Style(config);
    },
    updatePosition() {
      let position = this.position;
      position = this.$parent.worldToRosMap(position[0], position[1]);
      if (this.$point) {
        this.$point.setCoordinates(position);
      }
    },
  },
  beforeDestroy() {
    this.$parent.$map.removeLayer(this.$vectorLayer);
  },
  watch: {
    position(val) {
      if (val.length > 0) {
        this.updatePosition();
      }
    },
  },
};
</script>

<style>
</style>